exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-content[data-v-76cd452e]{margin-top:20px}", ""]);

// exports
